import { render, staticRenderFns } from "./zTest.vue?vue&type=template&id=72b364c1&scoped=true"
import script from "./zTest.vue?vue&type=script&lang=js"
export * from "./zTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b364c1",
  null
  
)

export default component.exports